import { render, staticRenderFns } from "./CardValidaFinger.vue?vue&type=template&id=ff53487a"
import script from "./CardValidaFinger.vue?vue&type=script&lang=js"
export * from "./CardValidaFinger.vue?vue&type=script&lang=js"
import style0 from "./CardValidaFinger.vue?vue&type=style&index=0&id=ff53487a&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff53487a')) {
      api.createRecord('ff53487a', component.options)
    } else {
      api.reload('ff53487a', component.options)
    }
    module.hot.accept("./CardValidaFinger.vue?vue&type=template&id=ff53487a", function () {
      api.rerender('ff53487a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/OnboardingDetailPerson/components/CardValidaFinger.vue"
export default component.exports